export default "__VITE_ASSET__RZpR$nvE__"